export default "__VITE_ASSET__BQNNQK6u__"